import { render, staticRenderFns } from "./StatusToggle.vue?vue&type=template&id=a2590fa2&scoped=true"
import script from "./StatusToggle.vue?vue&type=script&lang=js"
export * from "./StatusToggle.vue?vue&type=script&lang=js"
import style0 from "./StatusToggle.vue?vue&type=style&index=0&id=a2590fa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2590fa2",
  null
  
)

export default component.exports